import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
    faFacebook,
    faInstagram,
    faTiktok,
} from "@fortawesome/free-brands-svg-icons";
import "./Footer.scss";
import {useNavigate} from "react-router-dom";

function Footer() {
    const navigate = useNavigate();

    const handleClickLinkFooter = (link) => {
        navigate(link);
        window.scrollTo(0, 0);
    }

    const handleClickSocials = (redirection) => {
        redirection === "facebook"
            ? window.open(
                "https://www.facebook.com/profile.php?id=100075994402255",
                "_blank"
            )
            : redirection === "instagram"
                ? window.open(
                    "https://www.instagram.com/anneso2273/?igshid=OGQ5ZDc2ODk2ZA%3D%3D",
                    "_blank"
                )
                : window.open("https://www.tiktok.com/@anneso2273", "_blank");
    };

    return (
        <footer className="lmj-footer">
            <div className="lmj-footer-elem">
                <div className="div-main-elements-footer">
                    <div className="footer-text">
                        <h2>Chez Anne'so Naturelle</h2>
                        <p>Bienvenue chez Anne'so Naturelle, où chaque bijou, conçu avec soin, rayonne d'authenticité. Découvrez nos bracelets faits main, empreints d'énergie naturelle. Chaque création reflète la beauté simple et la tranquillité. Plongez dans notre univers où la créativité rencontre le bien-être.</p>
                    </div>
                    
                    <div className="div-menu-plus-informations-footer">
                        <div className="div-menu-footer">
                            <h3>Menu</h3>
                            <span className="liens-footer" onClick={() => handleClickLinkFooter("/")}>Accueil</span>
                            <span className="liens-footer" onClick={() => handleClickLinkFooter("/collections")}>Nos Collections</span>
                            <span className="liens-footer" onClick={() => handleClickLinkFooter("/profil/infos-persos")}>Mon compte</span>
                            <span className="liens-footer" onClick={() => handleClickLinkFooter("/panier")}>Mon panier</span>
                            <span className="liens-footer" onClick={() => handleClickLinkFooter("/apropos")}>Notre histoire</span>
                            <span className="liens-footer" onClick={() => handleClickLinkFooter("/contact")}>Contact</span>
                        </div>
                        
                        <div className="div-informations-footer">
                            <h3>Informations</h3>
                            <span className="liens-footer" onClick={() => handleClickLinkFooter("/informations/conditions-generales-ventes-et-utilisations")}>Conditions générales de vente et d'utilisation</span>
                            <span className="liens-footer" onClick={() => handleClickLinkFooter("/informations/retractation")}>Droit de rétractation</span>
                            <span className="liens-footer" onClick={() => handleClickLinkFooter("/informations/politique-confidentialite")}>Politique de confidentialité</span>
                            <span className="liens-footer" onClick={() => handleClickLinkFooter("/informations/mentions-legales")}>Mentions Légales</span>
                            <span className="liens-footer" onClick={() => handleClickLinkFooter("/informations/paiements-securise")}>Paiement sécurisé</span>
                            <a className="liens-footer" href="https://koari.fr">KOARI</a>
                        </div>
                    </div>
                </div>
                
                <div className="icon-socials">
                    <FontAwesomeIcon
                        className="iconSocial"
                        icon={faFacebook}
                        onClick={() => handleClickSocials("facebook")}
                        title="Facebook"
                    />
                    <FontAwesomeIcon
                        className="iconSocial"
                        icon={faInstagram}
                        onClick={() => handleClickSocials("instagram")}
                        title="Instagram"
                    />
                    <FontAwesomeIcon
                        className="iconSocial"
                        icon={faTiktok}
                        onClick={() => handleClickSocials("tiktok")}
                        title="TikTok"
                    />
                </div>
            </div>
            <p className="copyright-footer">© 2025, Anne'so Naturelle - anneso.naturelle@gmail.com</p>
        </footer>
    );
}

export default Footer;
